import { useState } from "react";
import { Box, Button, Drawer, IconButton, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import AddIcon from "@mui/icons-material/Add";
import "../Styles/headerfooter.css";
import { useAuth } from "../Context/authContext";

const OPEN_WIDTH = 260;
const TAB_SIZE = 56;

export default function CollapsibleSideMenu() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        display: {
          xs: "block",
          md: "none",
        },
      }}
      className="side-menu"
    >
      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            width: open ? OPEN_WIDTH : 0,
            overflow: "visible",
            transition: "width 250ms ease",
            borderRight: (t) =>
              open ? `2px solid ${t.palette.secondary.main}` : "none",
          },
        }}
      >
        <Box
          sx={{
            width: OPEN_WIDTH,
            height: "100%",
            display: open ? "block" : "none",
            bgcolor: "primary.main",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              p: 1,
            }}
          >
            <Box>
              <a href="/">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "70px",
                    width: "140px",
                  }}
                >
                  <Box
                    component="img"
                    src={
                      require("../Media/EBS_MONOGRAM_LOGO_WHITE_RGB.svg")
                        .default
                    }
                    alt="EBS logo"
                    className="logo"
                  />
                  {/* <Typography variant="title">Projects</Typography> */}
                </Box>
              </a>
            </Box>
            <Box
              sx={{
                mt: 2,
              }}
            >
              <IconButton
                onClick={() => setOpen(false)}
                className="burger-close"
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  isolation: "isolate",
                  background: "#001f4c",
                  color: "#fff",

                  "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    background:
                      "radial-gradient(circle at center, #001f4c 0%, #6fdeb9 90%, #6fdeb9 100%)",
                    opacity: 0,
                    transition: "opacity 0.2s ease",
                    zIndex: -1,
                  },

                  "&:hover::after": {
                    opacity: 1,
                  },
                }}
              >
                <ChevronLeftIcon color="text" />
              </IconButton>
            </Box>
          </Box>
          {user && (
            <Stack direction="column" className="burger-nav">
              <Button
                size="large"
                endIcon={<AddIcon />}
                variant="burgerNav"
                color="primary"
                href="/project/new"
              >
                <Box component="span" sx={{ ml: 2.5 }}>
                  New Project
                </Box>
              </Button>
              {user.userData.userRoles.includes("Administrator") && (
                <Button variant="burgerNav" color="primary" href="/dashboard">
                  <Box component="span" sx={{ ml: 2.5 }}>
                    Admin
                  </Box>
                </Button>
              )}
              {(user.userData.userRoles.includes("Administrator") ||
                user.userData.userRoles.includes("Accounting")) && (
                <Button variant="burgerNav" color="primary" href="/accounting">
                  <Box component="span" sx={{ ml: 2.5 }}>
                    Accounting
                  </Box>
                </Button>
              )}
            </Stack>
          )}
        </Box>
      </Drawer>

      {!open && (
        <Box
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            width: TAB_SIZE / 2,
            height: TAB_SIZE,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            borderRadius: `0 ${TAB_SIZE}px ${TAB_SIZE}px 0`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            boxShadow: 3,
          }}
        >
          <MenuIcon sx={{ ml: 0.5 }} />
        </Box>
      )}
    </Box>
  );
}
